module.exports = __webpack_public_path__ + "static/70-43e20ccbda4545d7dc603d2806a551b6.jpg";